import { render, staticRenderFns } from "./CombinationsTotalWidth.vue?vue&type=template&id=10b05a75&scoped=true"
import script from "./CombinationsTotalWidth.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsTotalWidth.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsTotalWidth.vue?vue&type=style&index=0&id=10b05a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b05a75",
  null
  
)

export default component.exports